module.exports = __webpack_public_path__ + "img/logo_en.e5deccb7.png";